import * as React from "react";
import { useState, useEffect, useCallback, useMemo, useRef } from "react";
// @mui material components
import { Box, Grid, Chip, Button, Card, Typography, Tooltip, Alert, List, ListItem, ListItemText, Dialog, FormLabel, DialogTitle, DialogContent, DialogActions, AppBar, Toolbar, IconButton, Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { DatePicker, DesktopTimePicker } from "@mui/x-date-pickers";
import Checkbox from "@mui/material/Checkbox";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import Label from 'components/label/Label';
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EditIcon from '@mui/icons-material/Edit';
import DownloadIcon from '@mui/icons-material/Download';
import { getSignatureList } from 'api/users';
import AxisCalculator from "./AxisCalculator";
import { ObjectId } from "bson";


import axios from "axios";
// Others
import CustomInputLabel from "components/custom-input-label";
import customStyle from "customstyle.module.css";
import dayjs from "dayjs";

// Data
import { signatures_live as signatures } from "client-config";
import findingsData from "layouts/manual-Interpretation/data/findingsData";
import suggestedActionsData from "layouts/manual-Interpretation/data/suggestedActionsData";
import findingDefaultLeads from "layouts/manual-Interpretation/data/defaultLeadsSelectionFindings";




// import arryhthmiaData from "layouts/manual-Interpretation/data/arryhthmiaData";
// import stemiData from "layouts/manual-Interpretation/data/stemiData";
// import arrhythmiaTextData from "layouts/manual-Interpretation/data/arrhythmiaTextData";
import stemiTextData from "layouts/manual-Interpretation/data/stemiTextData";
import { useSnackbar } from 'components/snackbar'
import LeadTraceMatrixSection from "./LeadTraceMatrixSection";
import DoctorPrescription from "utils/doctorPrescription";
import { getPrescription, LeadTraceMatrix } from "api/reports";
import { useNavigate } from 'react-router-dom';
// import account from "_mock/account";
import { useAuthDispatch } from 'components/AuthStateProvider';

import AddIcon from '@mui/icons-material/Add';

const DEFAULT_LEADS_MAP = findingDefaultLeads.reduce((acc, f) => {
  acc[f._id] = f.leads;
  return acc;
}, {});

// import Typography from "theme/overrides/Typography";

function CustomReportInputForm({ formKey, displayData, inputData, handleReportInputFormSubmit, businessName, subsDetails, reportData, prescriptionUrl, isLTData, leadReplica }) {
  // alert(inputData);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { account } = useAuthDispatch();
  const leadMatrixRef = useRef();

  const normalizeSignatureValue = (value) => {
    if (!value) return "";
    if (value.startsWith("http")) return value;
    return `https://cdn-for-sunfox-website.s3.ap-south-1.amazonaws.com/signatures/${value}`;
  };


  // const [formInput, setFormInputs] = useState(inputData);
  // const [formInput, setFormInputs] = useState(() => ({
  //   ...inputData,
  //   suggested_actions: normalizeSuggestedActions(inputData?.suggested_actions)
  // }));

  const [formInput, setFormInputs] = useState(() => ({
    ...inputData,
    signature_of: normalizeSignatureValue(inputData?.signature_of),
    suggested_actions: normalizeSuggestedActions(inputData?.suggested_actions)
  }));



  const [pdfLoading, setPdfLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isFormChanged, setIsFormChanged] = useState(false);
  const [arrhythmiaSuggetions, setArrhythmiaSuggetions] = useState();
  const [leadTraceData, setLeadTraceData] = useState(inputData?.ecg_quality_matrix);
  const [prescriptionButton, setPrescriptionButton] = useState(false)
  const [openPrescription, setOpenPrescription] = useState(false)
  let prescriptionContents = ""
  const [prescriptionContent, setPrescriptionContent] = useState("")
  const [prescriptionLoading, setPrescriptionLoading] = useState(false)

  const [saveAndCloseLoading, setSaveAndCloseLoading] = useState(false);



  const [referredToValue, setReferredToValue] = useState("") // default to empty or an initial value

  const [savingLeadTrace, setSavingLeadTrace] = useState(false);

  const [intervalErrors, setIntervalErrors] = useState({});
  const [suggestedInputText, setSuggestedInputText] = useState("");
  const [signatures, setSignatures] = useState([]);
  const [signatureLoading, setSignatureLoading] = useState(true);
  const [findingsError, setFindingsError] = useState("");


  useEffect(() => {
    if (!signatureLoading && signatures.length > 0) {

      const subscriptionType =
        subsDetails?.subscription_type?.toLowerCase();

      const isPaidFlow =
        businessName ||
        subscriptionType === "trial" ||
        subscriptionType === "paid" ||
        reportData?.payment?.payment_id;

      let selectedSign;

      // Always use a stable, non-changeable identifier (like phoneNumber or id)
      // instead of name or value.
      // Even if the doctor's name or signature URL changes,
      // this will still correctly select the intended signature.

      if (isPaidFlow) {
        selectedSign = signatures.find(
          (sig) => sig.phoneNumber === "+911234566666"
        );
      } else {
        selectedSign = signatures.find(
          (sig) => sig.phoneNumber === expertPhoneNumber
        );
      }

      if (!selectedSign) {
        selectedSign = signatures.find(sig => sig.default) || signatures[0];
      }

      if (selectedSign) {
        setFormInputs(prev => ({
          ...prev,
          signature_of: selectedSign.value
        }));
      }
    }
  }, [signatureLoading, signatures, businessName, subsDetails, reportData]);

  useEffect(() => {
    const fetchSignatures = async () => {
      try {
        const res = await getSignatureList();

        if (res?.success) {
          const formatted = (res.data || []).map((sig) => ({
            name: sig.name,
            value: sig.sign_url,   // image URL
            phoneNumber: sig.phoneno,
            default: sig.default || false,
            qualification: sig.type,
          }));

          setSignatures(formatted);
        }
      } catch (error) {
        console.error("Failed to load signatures", error);
      } finally {
        setSignatureLoading(false);
      }
    };

    fetchSignatures();
  }, []);

  const ALL_LEADS = ["Lead I", "Lead II", "Lead III", "aVR", "aVL", "aVF", "V1", "V2", "V3", "V4", "V5", "V6"];

  const [selectedFindings, setSelectedFindings] = useState([]);
  const [findingLeadsMap, setFindingLeadsMap] = useState({});

  const [isAddingCustom, setIsAddingCustom] = useState(false);
  const [customFindingName, setCustomFindingName] = useState("");
  const [customFindingLeads, setCustomFindingLeads] = useState([]);
  const [open, setOpen] = useState(false);



  const generateId = () => new ObjectId().toString();


  const MASTER_FINDINGS_MAP = findingsData.reduce((acc, item) => {
    acc[item._id] = item;
    return acc;
  }, {});

  const toggleAllLeadsForFinding = (findingId, checked) => {
    setFindingLeadsMap(prev => {
      const current = prev[findingId] || {};

      return {
        ...prev,
        [findingId]: {
          ...current,
          leads: checked ? ALL_LEADS : [],

        }
      };
    });
  };

  const isAllLeadsSelected = (findingId) => {
    return (findingLeadsMap[findingId]?.leads || []).length === ALL_LEADS.length;
  };

  let expertPhoneNumber;
  const expertDetails = localStorage.getItem("TokenDetails") && JSON.parse(localStorage.getItem("TokenDetails"))
  if (expertDetails?.userType === "expert") {
    expertPhoneNumber = expertDetails?.phoneNumber;
  }

  // parse subs_details attributes
  if (subsDetails) {
    subsDetails["subscription_type"] = (subsDetails["subscription_type"] || subsDetails["subscriptionType"]) || ""
    subsDetails["plan_name"] = subsDetails["subscription_type"] ? (subsDetails["plan_name"] || subsDetails["planName"]) : ""
    if (!subsDetails["subscription_type"]) subsDetails = null
  }

  useEffect(() => {
    document.getElementById("report-input-form");
    setPdfLoading(false)
  }, [inputData]);

  useEffect(() => {
    // Check if there are any changes in form values
    const isFormChanged = Object.keys(formInput).some(
      key => formInput[key] !== inputData[key]
    );
    if ((formInput?.report_status === "critical" || formInput?.report_status === "abnormal" || formInput?.report_status === "beyond_critical")) {
      setPrescriptionButton(true);
    } else {
      setPrescriptionButton(false);
    }
    setIsFormChanged(isFormChanged);

  }, [formInput]);

  useEffect(() => {
    const { findings, findings_details } =
      formatFindingsForForm(findingLeadsMap);
    setFormInputs(prev => ({
      ...prev,
      findings,
      findings_details
    }));
  }, [findingLeadsMap]);




  useEffect(() => {
    // Only parse from inputData if we don't have local selections yet
    // OR if inputData truly changed from a server-side load
    if (Array.isArray(inputData?.findings_details) && selectedFindings.length === 0) {
      const { selectedFindings: backendFindings, findingLeadsMap: backendMap } =
        parseFindingsFromBackend(inputData.findings_details);

      setSelectedFindings(backendFindings);
      setFindingLeadsMap(backendMap);
    }
  }, [inputData]);


  function readFileAsync(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = function (event) {
        resolve(event.target.result);
      };

      reader.onerror = function (event) {
        reject(event.target.error);
      };

      reader.readAsDataURL(file);
    });
  }
  const handleOpenPrescription = async (e) => {

    setPrescriptionLoading(true)
    if (reportData) {
      const prescription = await getPrescription(reportData?.id)
      if (prescription?.data) {
        setPrescriptionLoading(false)
        setPrescriptionContent(prescription?.data?.html_data)
      }
      setOpenPrescription(true);
      setPrescriptionLoading(false)

    }
  };

  const handleClosePrescription = () => {
    setOpenPrescription(false);
    setPrescriptionContent(prescriptionContents)
  };

  const handleContentChange = (content, pdfData, isSave) => {
    prescriptionContents = content;
    if (isSave) {
      setFormInputs((values) => ({
        ...values,
        "prescription_data": content,
        "prescription_pdf": pdfData
      }));
      handleClosePrescription();
    }
  };

  const handleChange = async (event) => {
    let interval = "";
    const name = event.target.name;
    const value = event.target.value;
    if ((value === "critical" || value === "abnormal" || value === "beyond_critical")) {
      setPrescriptionButton(true);
    } else {
      setPrescriptionButton(false);
    }
    setFormInputs((values) => ({ ...values, [name]: value }));
    setPdfLoading(false)
    if (name.includes("_box")) {
      // allow empty
      if (value === "") {
        setIntervalErrors(prev => ({ ...prev, [name]: false }));
        setFormInputs(values => ({
          ...values,
          [name]: "",
          [name.replaceAll("_box", "")]: ""
        }));
        return;
      }

      //block non-numeric
      if (!/^\d+(\.\d+)?$/.test(value)) {
        setIntervalErrors(prev => ({ ...prev, [name]: true }));
        return; //STOP calculation here
      }

      //valid numeric value
      setIntervalErrors(prev => ({ ...prev, [name]: false }));

      interval = (parseFloat(value) * 40).toFixed(0);

      setFormInputs(values => ({
        ...values,
        [name]: value,
        [name.replaceAll("_box", "")]: interval
      }));
    }
    if (name === "rr_interval_box") {
      setFormInputs((values) => ({
        ...values,
        ["heart_rate"]: interval !== "" ? (60000 / parseFloat(interval)).toFixed(0) : "",
        ["qtc"]: calculateQTC(formInput["qt_interval"], interval),
      }));
    }
    if (name === "pp_interval_box") {
      setFormInputs((values) => ({
        ...values,
        ["atrial_rate"]: interval !== "" ? (60000 / parseFloat(interval)).toFixed(0) : "",
        ["qtc"]: calculateQTC(formInput["pp_interval"], interval),
      }));
    }
    if (name === "qt_interval_box") {
      setFormInputs((values) => ({
        ...values,
        ["qtc"]: calculateQTC(formInput["qt_interval"], formInput["rr_interval"]),
      }));
    }

    if (name === "interpreted_report_file") {
      const file = event.target.files[0];

      try {
        const base64String = await readFileAsync(file);
        setFormInputs((values) => ({
          ...values,
          ["interpreted_report_file"]: base64String,
          ["interpreted_report_file_metadata"]: {
            name: file?.name,
            size: file?.size,
            last_modified_at: file?.lastModified,
            type: file?.type
          },
        }));
      } catch (error) {
        console.error('Error reading file:', error);
      }
    }
  };


  function calculateQTC(qt, rr) {
    if (qt && rr) {
      return parseInt((parseFloat(qt) / 1000 / Math.sqrt(parseFloat(rr) / 1000)) * 1000);
    } else {
      return "";
    }
  }


  const formatFindingsForForm = (findingLeadsMap) => {
    const findings = [];
    const findings_details = [];

    Object.entries(findingLeadsMap).forEach(([id, value]) => {
      const masterFinding = MASTER_FINDINGS_MAP[id];
      const name = masterFinding?.name || value?.name || "";


      if (!name) return;
      const isCustom = !masterFinding;
      findings.push(name);

      findings_details.push({
        _id: id,
        name,
        ...(isCustom && { type: "OTHERS" }),
        leads: value?.leads || []
      });
    });

    return { findings, findings_details };
  };

  const parseFindingsFromBackend = (findingsDetails = []) => {
    const selectedFindings = [];
    const findingLeadsMap = {};

    findingsDetails.forEach(({ _id, name, leads = [] }) => {
      const masterFinding = MASTER_FINDINGS_MAP[_id];

      selectedFindings.push({
        _id,
        name: masterFinding?.name || name
      });

      findingLeadsMap[_id] = {
        _id,
        name: masterFinding?.name || name,
        leads
      };
    });

    return { selectedFindings, findingLeadsMap };
  };

  const toggleLeadForFinding = (findingId, lead, checked) => {
    setFindingLeadsMap(prev => {
      const current = prev[findingId] || {
        name: MASTER_FINDINGS_MAP[findingId]?.name || "",
        leads: []
      };

      const currentLeads = current.leads || [];

      const updatedLeads = checked
        ? [...currentLeads, lead]
        : currentLeads.filter(l => l !== lead);

      return {
        ...prev,
        [findingId]: {
          ...current,
          leads: updatedLeads,

        }
      };
    });
  };


  const handleSaveCustomFinding = () => {
    if (!customFindingName.trim()) return;

    const newFinding = {
      _id: generateId(),
      name: customFindingName.trim()
    };

    setSelectedFindings(prev => [...prev, newFinding]);

    setFindingLeadsMap(prev => ({
      ...prev,
      [newFinding._id]: {
        name: newFinding.name,
        leads: customFindingLeads
      }
    }));


    // reset
    setCustomFindingName("");
    setCustomFindingLeads([]);
    setIsAddingCustom(false);
    setIsAddingCustom(false);
    setOpen(true); // keep dropdown open

  };

  const toggleCustomLead = (lead) => {
    setCustomFindingLeads(prev =>
      prev.includes(lead)
        ? prev.filter(l => l !== lead)
        : [...prev, lead]
    );
  };

  const autocompleteOptions = useMemo(() => {
    const customSelected = selectedFindings.filter(
      f => !MASTER_FINDINGS_MAP[f._id]
    );

    return [
      ...findingsData,
      ...customSelected,
      { _id: "ADD_NEW", name: "+ Add New" }
    ];
  }, [selectedFindings]);


  // const handleFindingsChange = (event, newValue) => {
  //     const hasAddNew = newValue.some((v) => v._id === "ADD_NEW");

  //     if (hasAddNew) {
  //       setIsAddingCustom(true);
  //       return;
  //     }

  //     setSelectedFindings(newValue);

  //     // Initialize leads map for new selections using DEFAULT_LEADS_MAP
  //     setFindingLeadsMap((prev) => {
  //       const updated = { ...prev };

  //       // 1. Cleanup: Remove items no longer in the selection
  //       const newIds = new Set(newValue.map((f) => f._id));
  //       Object.keys(updated).forEach((id) => {
  //         if (!newIds.has(id)) delete updated[id];
  //       });

  //       // 2. Addition: Add new findings with their default leads
  //       newValue.forEach((f) => {
  //         if (!updated[f._id]) {

  //           const isInterpreted = reportData?.interpretation_request_status === "completed";

  //           const defaultLeads =
  //             !isInterpreted && DEFAULT_LEADS_MAP[f._id]
  //               ? [...DEFAULT_LEADS_MAP[f._id]]
  //               : [];
  //           updated[f._id] = {
  //             _id: f._id,
  //             name: f.name,
  //             leads: defaultLeads

  //           };
  //         }
  //       });

  //       return updated;
  //     });
  //   };

  const handleFindingsChange = (event, newValue) => {
    const hasAddNew = newValue.some((v) => v._id === "ADD_NEW");

    if (hasAddNew) {
      setIsAddingCustom(true);
      return;
    }

    //  Detect if it's removal or addition
    const isAdding = newValue.length > selectedFindings.length;

    //  Only validate errors when ADDING a new finding
    if (isAdding) {
      for (const finding of selectedFindings) {
        const leads = findingLeadsMap[finding._id]?.leads || [];

        if (leads.length === 0) {
          setFindingsError(`Please select at least one lead for "${finding.name}"`);
          return; // block ONLY addition
        }
      }
    }

    //  Allow removal always
    setFindingsError("");
    setSelectedFindings(newValue);

    setFindingLeadsMap((prev) => {
      const updated = { ...prev };

      const newIds = new Set(newValue.map((f) => f._id));

      // cleanup removed findings
      Object.keys(updated).forEach((id) => {
        if (!newIds.has(id)) delete updated[id];
      });

      // add new findings
      newValue.forEach((f) => {
        if (!updated[f._id]) {
          const isInterpreted = reportData?.interpretation_request_status === "completed";

          const defaultLeads =
            !isInterpreted && DEFAULT_LEADS_MAP[f._id]
              ? [...DEFAULT_LEADS_MAP[f._id]]
              : [];

          updated[f._id] = {
            _id: f._id,
            name: f.name,
            leads: defaultLeads
          };
        }
      });

      return updated;
    });
  };
  const handleFindingsMultiSelect = (event, selectedOptions) => {
    setFindingLeadsMap(prev => {
      const updated = {};

      selectedOptions.forEach(option => {
        const id = option._id;

        if (prev[id]) {
          updated[id] = prev[id];
          return;
        }

        updated[id] = {
          _id: id,
          name: option.name,
          leads: DEFAULT_LEADS_MAP[id]
            ? [...DEFAULT_LEADS_MAP[id]]
            : []
        };
      });

      return updated;
    });
  };


  function suggestedActions(selectedValues, isRemove) {
    let sugg = formInput["suggested_actions"] || "";
    let resultText = "";
    //Remove All prv selected text
    const newLine = "\n";
    for (var value of findingsData) {
      sugg = sugg.replaceAll(`${value}${newLine}`, "");
    }
    if ((selectedValues || []).length)
      selectedValues.map((item) => {
        if (!sugg.match(item)) resultText += `${item}${newLine}`;
      });
    if (resultText !== "") {
      sugg += resultText;
    }
    setFormInputs((values) => ({
      ...values,
      // ["suggested_actions"]: sugg,
      findings: selectedValues,
    }));
  }

  const handleArrhymiaChange = (event, selectedOptions, reason) => {
    commonAutoCompleteChange(event, selectedOptions, reason, "Arrhymia");
  };

  const handleStemiChange = (event, selectedOptions, reason) => {
    commonAutoCompleteChange(event, selectedOptions, reason, "Stemi");
  };

  function commonAutoCompleteChange(event, selectedOptions, reason, elKey) {
    let result = null;
    if (reason === "clear") {
      if (elKey === "Arrhymia") {
        suggetionsFromArrhymia();
      } else if (elKey === "Stemi") {
        suggetionsFromStemi();
      }
    } else if (reason === "selectOption" || reason === "removeOption") {
      if (selectedOptions.find((option) => option.value === "select-all")) {
        //handleToggleSelectAll();
        // let result = [];
        result = items.filter((el) => el.value !== "select-all");
        // onChange(result);
      } else {
        //handleToggleOption(selectedOptions);
        result = selectedOptions;
        // onChange(selectedOptions);
      }
      const resultKey = {};
      result.map((item) => {
        resultKey[item.title] = true;
      });
      if (elKey === "Arrhymia") {
        suggetionsFromArrhymia(resultKey);
      } else if (elKey === "Stemi") {
        suggetionsFromStemi(resultKey);
      }
    }
  }

  function suggetionsFromArrhymia(resultKey) {
    let resultText = "";
    var sugg = formInput["suggested_actions"] || "";
    if (resultKey) {
      //1. Atrial fibrillation
      if (
        (resultKey["pWaveAbsent"] == true &&
          resultKey["rrVariabilityThresholdgreater25"] == true) ||
        resultKey["interpWaveRategreater250"] == true
      ) {
        resultText += "\n Atrial Fibrillation";
      }
      //2. Atrial Flutter
      if (resultKey["intraprategreater250_350"] == true) {
        resultText += "\n Atrial Flutter";
      }
      //3. Atrial Tachycardia
      // Check for atrial tachycardia based on the combined criteria
      if (
        resultKey["heartRateGreaterThan100"] == true &&
        resultKey["pWaveDurationBetween150And250"] == true &&
        resultKey["narrowQRS"] == true
      ) {
        resultText += "\n Atrial Tachycardia";
      }
      //4. Junctional Rhythm
      // Check for junctional rhythm based on the combined
      //criteria
      if (
        resultKey["pWaveAbsent"] == true &&
        resultKey["heartRateGreaterThan60"] == true &&
        resultKey["rrVariabilityLessThan10(rrVariability)"] == true &&
        resultKey["narrowQRS"] == true
      ) {
        resultText += "\n Junctional Rhythm";
      }
      //5. High Degree AV block
      // Check for high-degree AV block based on the combined criteria
      if (
        resultKey["prolongedPRI"] == true &&
        resultKey["rrVariabilityGreaterThan20(rrVariability)"] == true
      ) {
        resultText += "\n High-Degree AV Block";
      }
      //6. AV block
      // Check for AV block based on the combined criteria
      if (resultKey["prolongedPRI"] == true && resultKey["rrVariabilityLessThan20"] == true) {
        resultText += "\n AV Block";
      }
      //7. WPW syndrome(pre - excitation)
      // Check for Wolff-Parkinson-White (WPW) syndrome based on the combined
      //criteria
      if (resultKey["shortenedPRInterval"] && resultKey["lurredRWave"] && resultKey["wideQRS"]) {
        resultText += "\n Wolff-Parkinson-White (WPW) Syndrome";
      }
      //8. SuperaVenticular Ectopics
      // Check for superaventricular ectopics based on the combined criteria
      if (resultKey["rrVariabilityGreaterThan25"] == true && resultKey["narrowQRS"] == true) {
        resultText += "\n Superaventricular Ectopics";
      }
      //9. Ventricular Ectopics
      // Check for ventricular ectopics based on the combined criteria
      if (resultKey["rrVariabilityGreaterThan25"] == true && resultKey["wideQRS"] == true) {
        resultText += "\n Ventricular Ectopics";
      }
      //10.Superaventricular Tachycardia
      // Check for Supraventricular Tachycardia (SVT) based on the combined
      //criteria
      if (
        resultKey["heartRateGreaterThan100"] &&
        resultKey["absentPWave"] &&
        resultKey["narrowQRS"]
      ) {
        resultText += "\n Supraventricular Tachycardia";
      }
      //11.Ventricular tachycardia
      // Check for Ventricular Tachycardia based on the combined criteria
      if (
        resultKey["heartRateGreaterThan100"] &&
        resultKey["absentPWave"] &&
        resultKey["wideQRS"]
      ) {
        resultText += "\n Ventricular Tachycardia";
      }
      //12.Ventricular premature Complex
      // Check for Ventricular Premature Contraction (VPC) based on the combined
      //criteria
      if (
        resultKey["superimposedPWave"] &&
        resultKey["stDiscordant"] &&
        resultKey["rrVariabilityGreaterThan25"] &&
        resultKey["wideQRS"]
      ) {
        resultText += "\n Ventricular Premature Contraction (VPC) Detected";
      }
      //13.Sinus Bradycardia
      // Check for Sinus Bradycardia based on the criteria
      if (resultKey["heartRateLessThan60"]) {
        resultText += "\n Sinus Bradycardia";
      }
      //14.Sinus Tachycarida
      // Check for Sinus Bradycardia based on the criteria
      if (resultKey["heartRategGreaterThan60"]) {
        resultText += "\n Sinus Tachycardia";
      }
    } else {
      resultText = "";
    }
    //Remove All prv selected text
    for (const value of (arrhythmiaSuggetions || [])) {
      sugg = sugg.replaceAll("\n " + value, "");
    }

    if (resultText !== "") {
      sugg += resultText;
    }
    setFormInputs((values) => ({ ...values, ["suggested_actions"]: sugg }));
  }

  function suggetionsFromStemi(resultKey) {
    let resultText = "";
    var sugg = formInput["suggested_actions"] || "";
    if (resultKey) {
      //1. Left bundle Branch block
      // Check for Left Bundle Branch Block (LBBB) based on the combined criteria
      if (resultKey["wideQRS"] && resultKey["dominantSV1"] && resultKey["notchedMShapeRWaveV5V6"]) {
        resultText += "\n Left Bundle Branch Block (LBBB)";
      }
      //2. Right Branch Bundle Block
      // Check for Right Bundle Branch Block (RBBB) based on the combined criteria
      if (resultKey["rBySRatioGreaterThan1InV1"] && resultKey["wideQRS"]) {
        resultText += "\n Right Bundle Branch Block (RBBB)";
      }
      //3. Anterior Wall MI
      // Check for Anterior Wall Myocardial Infarction (MI) based on the combined criteria
      if (
        resultKey["stElevationOrDepressionInV1"] &&
        resultKey["stElevationOrDepressionInV2"] &&
        resultKey["stElevationOrDepressionInV3"]
      ) {
        resultText += "\n Anterior Wall Myocardial Infarction (MI)";
      }
      //4. Antero - septal MI
      // Check for Antero-septal Myocardial Infarction (MI) based on the combined criteria
      if (
        resultKey["stElevationOrDepressionInV1"] &&
        resultKey["stElevationOrDepressionInV2"] &&
        resultKey["stElevationOrDepressionInV3"] &&
        resultKey["stElevationOrDepressionInV4"] &&
        resultKey["stElevationOrDepressionInV5"]
      ) {
        resultText += "\n Antero-septal Myocardial Infarction (MI)";
      }
      //5. Antero - Apical MI
      // Check for Antero-apical Myocardial Infarction (MI) based on the combined criteria
      if (
        resultKey["stElevationOrDepressionInLeadI"] &&
        resultKey["stElevationOrDepressionInLeadAVL"] &&
        resultKey["stElevationOrDepressionInV2"] &&
        resultKey["stElevationOrDepressionInV3"] &&
        resultKey["stElevationOrDepressionInV4"]
      ) {
        resultText += "\n Antero-apical Myocardial Infarction (MI)";
      }
      //6. Inferior wall MI
      // Check for Inferior Wall Myocardial Infarction (MI) based on the combined criteria
      if (
        resultKey["stElevationOrDepressionInLeadII"] &&
        resultKey["stElevationOrDepressionInLeadIII"] &&
        resultKey["stElevationOrDepressionInLeadAVF"]
      ) {
        resultText += "\n Inferior Wall Myocardial Infarction (MI)";
      }
      //7. Inferolateral MI
      // Check for Infero - lateral Wall Myocardial Infarction(MI) based on the combined criteria
      if (
        resultKey["stElevationOrDepressionInLeadII"] &&
        resultKey["stElevationOrDepressionInLeadIII"] &&
        resultKey["stElevationOrDepressionInLeadAVF"] &&
        resultKey["stElevationOrDepressionInLeadI"] &&
        resultKey["§stElevationOrDepressionInLeadAVL"]
      ) {
        resultText += "\n Infero-lateral Wall Myocardial Infarction (MI)";
      }

      //8. Lateral MI
      // Check for Lateral Wall Myocardial Infarction (MI) based on the combined criteria
      if (
        resultKey["stElevationOrDepressionInLeadI"] &&
        resultKey["stElevationOrDepressionInLeadAVL"] &&
        resultKey["stElevationOrDepressionInV5"] &&
        resultKey["stElevationOrDepressionInV6"]
      ) {
        resultText += "\n Lateral Wall Myocardial Infarction (MI) Detected";
      }
      //9. Ischemia
      // Check for ischemia based on the criteria
      if (resultKey["stSegmentDepression"] || resultKey["tWaveInversion"]) {
        resultText += "\n Ischemia";
      }
      //10.Left Ventricular Hypertrophy
      // Define the threshold for LVH diagnosis
      //int lvhThreshold = 5; //
      //Check for LVH based on the total score
      // if (resultKey["total_score"] > 5) {
      //   resultText += "\n Left Ventricular Hypertrophy(LVH)";
      // }
      //11.ST abnormality
      // Check for ST-T abnormality based on the criteria
      if (resultKey["stSegmentElevation"]) {
        resultText += "\n ST-T Abnormality";
      }
    } else {
      resultText = "";
    }
    //Remove All prv selected text
    for (var value of stemiTextData) {
      sugg = sugg.replaceAll("\n " + value, "");
    }
    if (resultText !== "") {
      sugg += resultText;
    }
    setFormInputs((values) => ({ ...values, ["suggested_actions"]: sugg }));
  }

  function onGenerateReportClick(e) {

    e.preventDefault();

    if (isFormChanged) {
      setFormInputs({
        ...formInput,
        date_of_receiving_ecg: formInput?.date_of_receiving_ecg || dayjs(parseInt(formInput?.requested_at)).format("DD/MM/YYYY"),
        time_of_receiving_ecg: formInput?.time_of_receiving_ecg || dayjs(parseInt(formInput?.requested_at)).format("hh:mm A"),
        time_of_ecg_interpretation: formInput?.time_of_ecg_interpretation || dayjs().format("hh:mm A"),
        signature_of: formInput?.signature_of || ((signatures || []).length > 0 ?
          (businessName || (subsDetails?.subscription_type?.toLowerCase() === "trial" || subsDetails?.subscription_type?.toLowerCase() === "paid" || reportData?.payment?.payment_id) ? (signatures.find(item => item["name"] === "Dr. Christianez Ratna") || signatures.find(item => item?.default))
            : signatures.find(item => item["phoneNumber"] === expertPhoneNumber) || signatures.find(item => item?.default))["value"]
          : null)
        ,
        report_status: formInput["report_status"] || "normal"
      });

      const isValidLeads = leadMatrixRef.current?.hasValidLeadSelections();

      if (!isValidLeads) {
        enqueueSnackbar(
          "Please select at least one option (Normal / Noise / Loose Electrodes etc.) for each LEAD before submitting.",
          { variant: "warning" }
        );
        return; // ⛔ Stop submission
      }
      setIsDialogOpen(true);
    } else {
      enqueueSnackbar("There is no update to save.", { variant: 'info' })
    }
  }

  const getReferralOptions = (type) => {

    if (type === 'expert') {
      return [
        { value: 'lead-expert', label: 'Refer to Expert 2' },
      ];
    } else if (type === 'lead-expert') {
      return [
        { value: 'doctor', label: 'Refer to Doctor' },
      ];
    }
    return []; // Default empty
  };

  const referralOptions = getReferralOptions(account?.userType);

  async function onConfirmSubmitClick(e, showLoading = true) {

    if (showLoading) setPdfLoading(true);

    const ecg_quality_matrix = {
      ...(leadTraceData || getDefaultLeadMetricesData()),
      ...otherMatrixDataMapping()
    };

    await handleReportInputFormSubmit(e, {
      ...formInput,
      suggested_actions: Array.isArray(formInput?.suggested_actions)
        ? formInput.suggested_actions
          .filter(Boolean)
          .map(item => item.trim())
          .join(", ")
        : formInput?.suggested_actions || "",
      referred_to: referredToValue,
      setPdfLoading,
      date_of_receiving_ecg: formInput?.date_of_receiving_ecg || dayjs(parseInt(formInput?.requested_at)).format("DD/MM/YYYY"),
      time_of_receiving_ecg: formInput?.time_of_receiving_ecg || dayjs(parseInt(formInput?.requested_at)).format("hh:mm A"),
      time_of_ecg_interpretation: formInput?.time_of_ecg_interpretation || dayjs().format("hh:mm A"),
      signature_of:
        formInput?.signature_of ||
        ((signatures || []).length > 0
          ? (businessName ||
            (subsDetails?.subscription_type?.toLowerCase() === "trial" ||
              subsDetails?.subscription_type?.toLowerCase() === "paid" || reportData?.payment?.payment_id)
            ? (signatures.find(item => item["name"] === "Dr. Christianez Ratna") ||
              signatures.find(item => item?.default))
            : signatures.find(item => item["phoneNumber"] === expertPhoneNumber) ||
            signatures.find(item => item?.default))["value"]
          : null),
      report_status: formInput["report_status"] || "normal",
      ecg_quality_matrix
    });

    if (showLoading) setPdfLoading(false);
    setIsDialogOpen(false);
  }

  const onCloseDialog = useCallback(() => {
    setIsDialogOpen(false);
  });

  const otherMatrixDataMapping = () => {
    let otherMatrices = {
      r_peaks: [],
      lbbb: false,
      st_elevation: false,
      st_dipression: false,
      mi_all: false
    }
    if (reportData) otherMatrices.r_peaks = reportData?.characteristics?.r_peak_points ?? []
    // if (formInput?.classification_of_abnormality === "LBBB") otherMatrices.lbbb = true
    if (formInput?.classification_of_abnormality === "ST-T Changes") otherMatrices.st_elevation = true
    if (formInput?.classification_of_abnormality === "Myocardial Infarction") otherMatrices.mi_all = true
    if (formInput?.findings?.includes("ST- depression and T-wave inversion")) otherMatrices.st_dipression = true

    return otherMatrices
  }
  const metricesLabels = {
    normal: "Acceptable Quality",
    noise: "Noise",
    lead_reconstruction_issue: "Lead Reconstruction Issue",
    baseline_wandering: "Baseline Wandering",
    loose_electrodes: "Loose Electrodes",
    lead_reversal: "Lead Reversal",
    garbage: "Garbage"
  };
  const metrices = ['normal', 'noise', 'lead_reconstruction_issue', 'baseline_wandering', 'loose_electrodes', 'lead_reversal', 'garbage']

  const notNormalMetrices = ["garbage"]
  // Lead trace metrix default data
  const getDefaultLeadMetricesData = () => {
    const leadOrder = [
      'lead1', 'lead2', 'lead3',
      'avr', 'avl', 'avf',
      'v1', 'v2', 'v3', 'v4', 'v5', 'v6'
    ];

    // Sort using the prefix before "_data"
    const leadKeys = (reportData?.leads || []).sort((a, b) => {
      const aKey = a.replace('_data', '');
      const bKey = b.replace('_data', '');
      return leadOrder.indexOf(aKey) - leadOrder.indexOf(bKey);
    });

    let lead_trace_quality = {}

    leadKeys.forEach((lead) => {
      const leadKey = `${lead}`;
      lead_trace_quality[leadKey] = {
        ...metrices.reduce((acc, type, i) => {
          acc[type] = false;   // default: all metrics unchecked
          // default: normal = true
          // acc[type] = i === 0; 
          return acc;
        }, {})
      };
    });

    return { lead_trace_quality, lead_2_q_pathalogical_wave: false };
  }

  const onLeadTraceMatrixUpdate = (updatedData) => {
    setLeadTraceData(updatedData)
  }
  const hasAnySelection = () => {
    if (!leadTraceData) return false;
    if (leadTraceData.lead_2_q_pathalogical_wave) return true;
    const ltq = leadTraceData.lead_trace_quality || {};
    return Object.values(ltq).some((leadRow) =>
      Object.values(leadRow || {}).some(Boolean)
    );
  };

  const handleSaveLTOData = async () => {
    if (!hasAnySelection()) {
      enqueueSnackbar(
        "Please select at least one lead quality option before saving.",
        { variant: "warning" }
      );
      return;
    }
    try {
      setSavingLeadTrace(true);
      const response = await LeadTraceMatrix({
        reportId: reportData?.id,
        ecg_quality_matrix: leadTraceData,
        status: "completed"
      });
      if (response) {
        enqueueSnackbar("Data saved successfully!", { variant: "success" });
        setSavingLeadTrace(false);
      } else {
        enqueueSnackbar("Failed to save data.", { variant: "error" });
        setSavingLeadTrace(false);
      }
    } catch (err) {
      console.error("Error while saving:", err);
      enqueueSnackbar("An error occurred while saving.", { variant: "error" });
      setSavingLeadTrace(false);
    }
  };

  function normalizeSuggestedActions(value) {
    if (!value) return [];

    // already an array → return as is
    if (Array.isArray(value)) return value;

    // string → split by comma
    if (typeof value === "string") {
      return value
        .split(",")
        .map(item => item.trim())
        .filter(Boolean);
    }

    return [];
  }

  return (
    <>
      <form
        id="report-input-form"
        onSubmit={onGenerateReportClick}
      >
        <Grid container spacing={2} style={{ position: "relative" }} margin={0} width="100%">
          {/* <div style={{ padding: '15px', position: 'sticky', top: 0, zIndex: 99999, width: '100%' }}> */}
          {formInput?.completed_at ? (
            <Label color='success' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0 10px' }}>
              <CustomInputLabel>
                Report generated at:{" "}
                <b>{dayjs(parseInt(formInput?.completed_at)).format("DD MMM, YYYY hh:mm A")}</b>
              </CustomInputLabel>
            </Label>
          ) :
            <Label color='info' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0 10px' }}>
              <CustomInputLabel>
                Report taken at:{" "}
                <b>{dayjs(parseInt(displayData?.report_timestamp)).format("DD MMM, YYYY hh:mm A")}</b>
              </CustomInputLabel>
            </Label>
          }
          {/* </div> */}
          <Card className={customStyle.dotedBorder}>
            <Grid container style={{ padding: "15px" }} spacing={2}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <DatePicker
                    key={`receive-date-${formKey}`}
                    label="Date of Receiving ECG"
                    name="date_of_receiving_ecg"
                    maxDate={dayjs()}
                    value={
                      formInput?.date_of_receiving_ecg
                        ? dayjs(formInput?.date_of_receiving_ecg, "DD/MM/YYYY")
                        : dayjs(parseInt(formInput?.requested_at))
                    }
                    format="DD/MM/YYYY"
                    closeOnSelect={true}
                    onAccept={(event) =>
                      handleChange({
                        target: {
                          name: "date_of_receiving_ecg",
                          value: dayjs(event).format("DD/MM/YYYY"),
                        },
                      })
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <DesktopTimePicker
                    key={`receive-time-${formKey}`}
                    label="Time of Receiving ECG"
                    openTo="hours"
                    size="small"
                    value={
                      formInput?.time_of_receiving_ecg
                        ? dayjs(formInput?.time_of_receiving_ecg, "hh:mm A")
                        : dayjs(parseInt(formInput?.requested_at))
                    }
                    onAccept={(event) =>
                      handleChange({
                        target: { name: "time_of_receiving_ecg", value: dayjs(event).format("hh:mm A") },
                      })
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <DesktopTimePicker
                    key={`gen-time-${formKey}`}
                    label="Time of ECG Interpretation"
                    openTo="hours"
                    value={
                      formInput?.time_of_ecg_interpretation
                        ? dayjs(formInput?.time_of_ecg_interpretation, "hh:mm A")
                        : dayjs()
                    }
                    onAccept={(event) =>
                      handleChange({
                        target: {
                          name: "time_Of_ecg_interpretation",
                          value: dayjs(event).format("hh:mm A"),
                        },
                      })
                    }
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ display: 'flex', padding: "5px 0", flexDirection: 'column', justifyContent: 'space-between', backgroundColor: "warning.lighter" }}>
                  {businessName && (<Box width='50%'>
                    <Label
                      color='warning'
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%',
                        padding: '0 10px',
                        m: 1
                      }}>
                      <CustomInputLabel>
                        {businessName && `Business Name: ${businessName}`}
                      </CustomInputLabel>
                    </Label>
                  </Box>)}

                  {(subsDetails ? (<Box>
                    <Chip
                      label={`${subsDetails.subscription_type} - ${subsDetails.plan_name}${reportData?.payment?.payment_id ? `, Paid - ${reportData?.payment?.payment_id}` : ''}`}
                      size="small"
                      color={subsDetails?.subscription_type?.toLowerCase() === "paid" ? 'success' : 'warning'}
                      sx={{ marginLeft: 1, fontSize: '10px', marginTop: 0, textTransform: 'capitalize' }}
                    />
                  </Box>) : (reportData?.payment?.payment_id && (
                    <Box>
                      <Chip
                        label={`Paid: ${reportData?.payment?.payment_id}`}
                        size="small"
                        color="success"
                        sx={{
                          marginLeft: 1,
                          fontSize: '10px',
                          marginTop: 0,
                          textTransform: 'capitalize',
                        }}
                      />
                    </Box>
                  ))
                  )}
                </Box>
              </Grid>

              {/* <Grid item xs={6}>
                <TextField variant="outlined"
                  fullWidth
                  label="First Name"
                  name="first_name"
                  value={formInput?.first_name || ""}
                  onChange={handleChange}
                  size="small" />
              </Grid> 
              <Grid item xs={6}>
                <TextField variant="outlined"
                  fullWidth
                  label="Last Name"
                  name="last_name"
                  value={formInput?.last_name || ""}
                  onChange={handleChange}
                  size="small" />
              </Grid>
              <Grid item xs={6}>
                <TextField variant="outlined"
                  fullWidth
                  label="Age"
                  name="age"
                  value={formInput?.age}
                  onChange={handleChange}
                  size="small" />
              </Grid>
              <Grid item xs={6}>
                <TextField fullWidth
                  select
                  name="gender"
                  label="Gender"
                  value={formInput?.gender || "-"}
                  SelectProps={{
                    native: true,
                  }}
                  onChange={handleChange}
                  size="small"
                >
                  <option key="-" value="-" selected disabled>Select</option>
                  <option key="male" value="male" >Male</option>
                  <option key="female" value="female" >Female</option>
                  <option key="other" value="other" >Other</option>
                </TextField>

              </Grid> */}

            </Grid>
          </Card>

          <Card className={customStyle.dotedBorder}>
            <Grid container style={{ padding: "15px" }} spacing={2}>
              {/* <Grid item xs={6}>
                <TextField fullWidth
                  select
                  name="any_symptom"
                  label="Any Symptom"
                  value={formInput["any_symptom"] || "Choose Anyone"}
                  SelectProps={{
                    native: true,
                  }}
                  onChange={handleChange}
                  size="small"
                >
                  <option key="Choose Anyone" value="Choose Anyone" selected disabled>Choose Anyone</option>
                  <option key="Chest Pain" value="Chest Pain" >Chest Pain</option>
                  <option key="Shortness of Breath" value="Shortness of Breath" >Shortness of Breath</option>
                  <option key="Any Other" value="Any Other" >Any Other</option>
                  <option key="No Symptoms" value="No Symptoms" >No Symptoms</option>
                  <option key="Tightness">Tightness</option>
                  <option key="Syncope">Syncope</option>
                  <option key="Excessive Perspiration">Excessive Perspiration</option>
                  <option key="Fatigue">Fatigue</option>
                  <option key="Palpitation">Palpitation</option>
                  <option key="Nausea">Nausea</option>
                  <option key="Arm/Shoulder/Jaw Pain">Arm/Shoulder/Jaw Pain</option>

                </TextField>

              </Grid> */}
              <Grid item xs={6}>
                <TextField fullWidth
                  select
                  name="nature_of_ecg"
                  label="Nature Of ECG"
                  value={formInput["nature_of_ecg"] || "Choose Anyone"}
                  SelectProps={{
                    native: true,
                  }}
                  onChange={handleChange}
                  size="small"
                >
                  <option key="Choose Anyone" value="Choose Anyone" selected disabled>Choose Anyone</option>
                  <option key="Normal ECG" value="Normal ECG" >Normal ECG</option>
                  <option key="Abnormal ECG" value="Abnormal ECG" >Abnormal ECG</option>
                  <option key="Critical ECG" value="Critical ECG" >Critical ECG</option>

                </TextField>
              </Grid>
              <Grid item xs={6}>
                <TextField fullWidth
                  select
                  name="classification_of_abnormality"
                  label="Classification of Abnormality"
                  value={formInput["classification_of_abnormality"] || "Choose Anyone"}
                  SelectProps={{
                    native: true,
                  }}
                  onChange={handleChange}
                  size="small"
                >
                  <option key="Choose Anyone" value="Choose Anyone" selected disabled>Choose Anyone</option>
                  <option key="Arrhythmia" value="Arrhythmia" >Arrhythmia</option>
                  <option key="Ischemia" value="Ischemia" >Ischemia</option>
                  <option key="Myocardial Infarction" value="Myocardial Infarction" >Myocardial Infarction</option>
                  <option key="ST-T Changes" value="ST-T Changes" >ST-T Changes</option>
                  <option key="J Point Elevation" value="J Point Elevation" >J Point Elevation</option>
                  {/* <option key="RBBB" value="RBBB" >RBBB</option> */}
                  {/* <option key="LBBB" value="LBBB" >LBBB</option> */}
                  <option key="BBB" value="Bundle Branch Block (BBB)" >Bundle Branch Block (BBB)</option>
                  <option key="None" value="None" >None</option>
                  <option key="STEMI" value="ST Elevated Myocardial Infarction (STEMI)" >ST Elevated Myocardial Infarction (STEMI)</option>
                  <option key="NSTEMI" value="Non-ST-Elevation Myocardial Infarction (NSTEMI)" >Non-ST-Elevation Myocardial Infarction (NSTEMI)</option>
                </TextField>

              </Grid>
              {/* <Grid item xs={6}>
                <TextField variant="outlined"
                  fullWidth
                  label="Total Score"
                  name="total_score"
                  value={formInput["total_score"]}
                  onChange={handleChange}
                  size="small" />
              </Grid> */}
            </Grid>
          </Card>
          <Card className={customStyle.dotedBorder}>
            <Grid container style={{ padding: "15px" }} spacing={2}>
              <Grid item xs={12}>
                <Autocomplete
                  multiple
                  disableCloseOnSelect

                  open={open}
                  onOpen={() => setOpen(true)}
                  onClose={(event, reason) => {
                    // 🚫 Prevent closing when interacting with Add New section
                    if (isAddingCustom && reason === "blur") return;
                    setOpen(false);
                  }}

                  id={`choose-findings-${formKey}`}
                  options={autocompleteOptions}
                  value={selectedFindings}
                  getOptionLabel={(option) => option.name || ""}
                  isOptionEqualToValue={(option, value) => option._id === value._id}
                  onChange={handleFindingsChange}

                  // Custom Tags (Chips)
                  renderTags={(value, getTagProps) =>
                    value.map((finding, index) => {
                      const leads = findingLeadsMap[finding._id]?.leads || [];

                      const label = leads.length === ALL_LEADS.length
                        ? `${finding.name} (All Leads)`
                        : leads.length > 0
                          ? `${finding.name} (${leads.join(", ")})`
                          : finding.name;

                      return (
                        <Chip
                          {...getTagProps({ index })}
                          key={finding._id}
                          label={label}
                          size="small"
                        />
                      );
                    })
                  }

                  // Custom Dropdown Items
                  renderOption={(props, option, { selected }) => {
                    // --- ADD NEW OPTION RENDERED INSIDE DROPDOWN ---
                    if (option._id === "ADD_NEW") {


                      return (

                        <li
                          {...props}
                          onMouseDown={(e) => {
                            e.preventDefault();   //  prevents Autocomplete from selecting & closing
                          }}
                          style={{ display: "block", borderTop: "1px solid #eee", padding: 0 }}
                        >

                          {!isAddingCustom ? (
                            // The initial clickable "+ Add New" button
                            <Box
                              sx={{ p: "10px", display: "flex", alignItems: "center", color: "primary.main", cursor: "pointer" }}
                              onClick={(e) => {
                                e.stopPropagation(); // Keep dropdown open
                                setIsAddingCustom(true);
                                setOpen(true);
                              }}
                            >
                              <AddIcon fontSize="small" sx={{ mr: 1 }} />
                              <Typography fontWeight={600}>Add New</Typography>
                            </Box>
                          ) : (
                            // The Inline Add New Form (matching Figma blue background)
                            <Box
                              sx={{ p: 2, bgcolor: "#f0f7ff", borderTop: "1px solid #cce3ff" }}

                              onClick={(e) => e.stopPropagation()}


                            >
                              <Typography variant="subtitle2" sx={{ mb: 1, color: "#1976d2" }}>
                                Add New Finding
                              </Typography>
                              <TextField
                                fullWidth
                                autoFocus
                                size="small"
                                placeholder="Enter Finding"
                                value={customFindingName}
                                onChange={(e) => setCustomFindingName(e.target.value)}
                                // onMouseDown={(e) => e.stopPropagation()}
                                onClick={(e) => e.stopPropagation()}
                                onKeyDown={(e) => {
                                  // Prevents 'Enter' key from closing the dropdown
                                  if (e.key === 'Enter') {
                                    e.stopPropagation();
                                    handleSaveCustomFinding();
                                  }
                                }}
                                sx={{ mb: 2, bgcolor: "white" }}
                              />

                              <Typography variant="caption" sx={{ display: "block", mb: 1, fontWeight: 600 }}>
                                Leads :
                              </Typography>

                              <Grid container spacing={0.5} sx={{ mb: 2 }}>
                                {[
                                  ["Lead I", "aVF", "V1", "V4"],
                                  ["Lead II", "aVR", "V2", "V5"],
                                  ["Lead III", "aVL", "V3", "V6"],
                                ].map((row, rowIndex) => (
                                  <Grid container item xs={12} key={rowIndex}>
                                    {row.map((lead) => (
                                      <Grid item xs={3} key={lead}>
                                        <FormControlLabel
                                          sx={{ m: 0 }}
                                          control={
                                            <Checkbox
                                              size="small"
                                              sx={{ p: 0.5 }}
                                              checked={customFindingLeads.includes(lead)}
                                              onChange={() => toggleCustomLead(lead)}
                                            />
                                          }
                                          label={<Typography fontSize="0.7rem">{lead}</Typography>}
                                        />
                                      </Grid>
                                    ))}
                                  </Grid>
                                ))}
                              </Grid>

                              <Box sx={{ display: "flex", gap: 1 }}>
                                <Button
                                  variant="contained"
                                  size="small"
                                  sx={{ textTransform: 'none' }}
                                  onClick={handleSaveCustomFinding}
                                >
                                  Add New
                                </Button>
                                <Button
                                  size="small"
                                  color="inherit"
                                  sx={{ textTransform: 'none' }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setIsAddingCustom(false);
                                  }}
                                >
                                  Cancel
                                </Button>
                              </Box>
                            </Box>
                          )}
                        </li>
                      );
                    }

                    // --- REGULAR FINDINGS ---
                    return (
                      <li {...props} style={{ display: "block" }}>
                        <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                          <Checkbox checked={selected} size="small" sx={{ mr: 1 }} />
                          <Typography variant="body2">{option.name}</Typography>
                        </Box>

                        {selected && (
                          <Box
                            onClick={(e) => e.stopPropagation()}
                            onMouseDown={(e) => e.preventDefault()}
                            sx={{ pl: 6, pr: 2, pb: 2, width: "100%" }}
                          >
                            <Typography variant="caption" sx={{ display: "block", mb: 0.5, color: "text.secondary" }}>
                              Leads :
                            </Typography>
                            <FormControlLabel
                              sx={{ mb: 1 }}
                              control={
                                <Checkbox
                                  size="small"
                                  checked={isAllLeadsSelected(option._id)}
                                  onChange={(e) => toggleAllLeadsForFinding(option._id, e.target.checked)}
                                />
                              }
                              label={<Typography variant="caption" fontWeight={600}>Select All Leads</Typography>}
                            />

                            <Grid container spacing={0.5}>
                              {[
                                ["Lead I", "aVF", "V1", "V4"],
                                ["Lead II", "aVR", "V2", "V5"],
                                ["Lead III", "aVL", "V3", "V6"],
                              ].map((row, rowIndex) => (
                                <Grid container item xs={12} key={rowIndex}>

                                  {row.map((lead) => (

                                    <Grid item xs={3} key={lead}>
                                      <FormControlLabel
                                        sx={{ m: 0 }}
                                        control={
                                          <Checkbox
                                            size="small"
                                            // sx={{ p: 0.5 }}
                                            sx={{
                                              p: 0.5,
                                              "&.Mui-checked": {
                                                // color: findingLeadsMap[option._id]?.isDefault ?  "#2e7d32" : undefined,
                                                color: (() => {
                                                  // 1. If it's an existing/saved report, everything is blue
                                                  if (formInput.interpretation_request_status === "completed") return "#1976d2";

                                                  // 2. If it's a new report, use the green-for-default logic
                                                  const defaults = DEFAULT_LEADS_MAP[option._id] || [];
                                                  return defaults.includes(lead) ? "#2e7d32" : "#1976d2";
                                                })(),

                                              },
                                            }}
                                            checked={(findingLeadsMap[option._id]?.leads || []).includes(lead)}
                                            onChange={(e) => toggleLeadForFinding(option._id, lead, e.target.checked)}
                                          />
                                        }
                                        label={<Typography fontSize="0.7rem">{lead}</Typography>}
                                      />
                                    </Grid>
                                  ))}
                                </Grid>
                              ))}
                            </Grid>
                          </Box>
                        )}
                      </li>
                    );
                  }}

                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Findings"
                      placeholder={selectedFindings.length > 0 ? "" : "Choose Multiple"}
                    />
                  )}
                />
                {findingsError && (
                  <Typography color="error" fontSize="0.8rem" mt={1}>
                    {findingsError}
                  </Typography>
                )}
              </Grid>

              <Grid item xs={12}>
                <Autocomplete
                  multiple
                  freeSolo
                  fullWidth
                  options={suggestedActionsData}
                  // value={normalizeSuggestedActions(formInput?.suggested_actions)}
                  value={formInput?.suggested_actions || []}

                  inputValue={suggestedInputText}
                  onInputChange={(event, newInputValue) => {
                    setSuggestedInputText(newInputValue);
                  }}
                  onChange={(event, value) => {
                    setFormInputs(prev => ({
                      ...prev,
                      suggested_actions: value
                    }));
                  }}
                  onBlur={() => {

                    if (suggestedInputText?.trim()) {
                      setFormInputs(prev => ({
                        ...prev,
                        suggested_actions: [
                          ...normalizeSuggestedActions(prev.suggested_actions),
                          suggestedInputText.trim()
                        ]
                      }));
                      setSuggestedInputText("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Suggested Actions"
                      placeholder="Select or type suggested actions"
                    // multiline
                    />
                  )}
                  sx={{
                    "& .MuiAutocomplete-inputRoot": {
                      alignItems: "flex-start",
                      maxHeight: 120,
                      overflowY: "auto",
                      paddingTop: "6px",
                      paddingBottom: "6px"
                    },
                    "& .MuiAutocomplete-tag": {
                      margin: "4px"
                    }
                  }}

                />

              </Grid>
              {/* Start PR Interval element */}
              <Grid item xs={4}>
                <TextField variant="outlined"
                  label="PR Interval Box"
                  name="pr_interval_box"
                  placeholder="Eg: 4.2"
                  value={formInput["pr_interval_box"] || ""}
                  onChange={handleChange}
                  size="small"
                  error={!!intervalErrors["pr_interval_box"]}
                  helperText={
                    intervalErrors["pr_interval_box"]
                      ? "Only numeric values allowed"
                      : ""
                  }
                  inputProps={{
                    inputMode: "decimal",
                    pattern: "[0-9.]*"
                  }}
                  onWheel={(e) => e.target.blur()}
                />

              </Grid>
              <Grid item xs={2}>
                <Typography mt={1} variant="caption" display="block" gutterBottom>
                  X 40 =
                </Typography>


              </Grid>
              <Grid item xs={4}>
                <TextField variant="outlined"
                  label="PR Interval"
                  name="pr_interval"
                  inputProps={{ tabIndex: "-1" }}
                  readOnly={true}
                  placeholder="PR Interval"
                  value={formInput["pr_interval"] || ""}
                  onChange={handleChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={2}>
                <Typography mt={1} variant="caption" display="block" gutterBottom>
                  ms
                </Typography>
              </Grid>
              {/* End Start PR Interval element */}

              {/* Start QRS Interval element */}
              <Grid item xs={4}>
                <TextField
                  label="QRS Interval Box"
                  name="qrs_interval_box"
                  placeholder="Eg: 4.2"
                  value={formInput["qrs_interval_box"] || ""}
                  onChange={handleChange}
                  size="small"
                  error={!!intervalErrors["qrs_interval_box"]}
                  helperText={
                    intervalErrors["qrs_interval_box"]
                      ? "Only numeric values allowed"
                      : ""
                  }
                  inputProps={{
                    inputMode: "decimal",
                    pattern: "[0-9.]*"
                  }}
                  onWheel={(e) => e.target.blur()}
                />
              </Grid>
              <Grid item xs={2}>
                <Typography mt={1} variant="caption" display="block" gutterBottom>
                  X 40 =
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <TextField variant="outlined"
                  label="QRS Interval"
                  name="qrs_interval"
                  inputProps={{ tabIndex: "-1" }}
                  readOnly={true}
                  placeholder="QRS Interval"
                  value={formInput["qrs_interval"] || ""}
                  onChange={handleChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={2}>
                <Typography mt={1} variant="caption" display="block" gutterBottom>
                  ms
                </Typography>
              </Grid>
              {/* End QRS Interval element */}

              {/* Start QT Interval element */}
              <Grid item xs={4}>
                <TextField
                  label="QT Interval Box"
                  name="qt_interval_box"
                  placeholder="Eg: 4.2"
                  value={formInput["qt_interval_box"] || ""}
                  onChange={handleChange}
                  size="small"
                  error={!!intervalErrors["qt_interval_box"]}
                  helperText={
                    intervalErrors["qt_interval_box"]
                      ? "Only numeric values allowed"
                      : ""
                  }
                  inputProps={{
                    inputMode: "decimal",
                    pattern: "[0-9.]*"
                  }}
                  onWheel={(e) => e.target.blur()}
                />
              </Grid>
              <Grid item xs={2}>
                <Typography mt={1} variant="caption" display="block" gutterBottom>
                  X 40 =
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <TextField variant="outlined"
                  label="QT Interval"
                  name="qt_interval"
                  inputProps={{ tabIndex: "-1" }}
                  readOnly={true}
                  placeholder="QTInterval"
                  value={formInput["qt_interval"] || ""}
                  onChange={handleChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={2}>
                <Typography mt={1} variant="caption" display="block" gutterBottom>
                  ms
                </Typography>
              </Grid>
              {/* End QT Interval element */}

              {/* Start ST Interval element */}
              <Grid item xs={4}>
                <TextField
                  label="ST Interval Box"
                  name="st_interval_box"
                  placeholder="Eg: 4.2"
                  value={formInput["st_interval_box"] || ""}
                  onChange={handleChange}
                  size="small"
                  error={!!intervalErrors["st_interval_box"]}
                  helperText={
                    intervalErrors["st_interval_box"]
                      ? "Only numeric values allowed"
                      : ""
                  }
                  inputProps={{
                    inputMode: "decimal",
                    pattern: "[0-9.]*"
                  }}
                  onWheel={(e) => e.target.blur()}
                />
              </Grid>
              <Grid item xs={2}>
                <Typography mt={1} variant="caption" display="block" gutterBottom>
                  X 40 =
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <TextField variant="outlined"
                  label="ST Interval"
                  name="st_interval"
                  inputProps={{ tabIndex: "-1" }}
                  readOnly={true}
                  placeholder="ST Interval"
                  value={formInput["st_interval"] || ""}
                  onChange={handleChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={2}>
                <Typography mt={1} variant="caption" display="block" gutterBottom>
                  ms
                </Typography>
              </Grid>
              {/* End ST Interval element */}

              {/* Start RR Interval element */}
              <Grid item xs={4}>
                <TextField
                  label="RR Interval Box"
                  name="rr_interval_box"
                  value={formInput["rr_interval_box"] || ""}
                  onChange={handleChange}
                  size="small"
                  error={!!intervalErrors["rr_interval_box"]}
                  helperText={
                    intervalErrors["rr_interval_box"]
                      ? "Only numeric values allowed"
                      : ""
                  }
                  inputProps={{
                    inputMode: "decimal",
                    pattern: "[0-9.]*"
                  }}
                  onWheel={(e) => e.target.blur()}
                />
              </Grid>
              <Grid item xs={2}>
                <Typography mt={1} variant="caption" display="block" gutterBottom>
                  X 40 =
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <TextField variant="outlined"
                  label="RR Interval"
                  name="rr_interval"
                  inputProps={{ tabIndex: "-1" }}
                  readOnly={true}
                  placeholder="RR Interval"
                  value={formInput["rr_interval"] || ""}
                  onChange={handleChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={2}>
                <Typography mt={1} variant="caption" display="block" gutterBottom>
                  ms
                </Typography>
              </Grid>
            </Grid>
          </Card>
          {/* End RR Interval element */}

          <Card className={customStyle.dotedBorder} sx={{ width: '100%' }}>
            <Grid container style={{ padding: "15px" }} spacing={2}>
              <Grid item xs={6}>
                <Typography mt={1} variant="caption" gutterBottom>
                  Heart Rate = <b>{formInput["heart_rate"] || ""}</b>
                  <br /> <em>[HR = 60000 / RR (ms)]</em>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField display="block" fullWidth
                  select
                  name="heart_rate_axis"
                  label="Heart Rate Axis"
                  value={formInput["heart_rate_axis"] || "Choose Axis"}
                  SelectProps={{
                    native: true,
                  }}
                  onChange={handleChange}
                  size="small"
                >
                  <option key="Choose Axis" value="Choose Axis" selected disabled>Choose Anyone</option>
                  <option key="Normal" value="Normal" >Normal</option>
                  <option key="Left Axis Deviation" value="Left Axis Deviation" >Left Axis Deviation</option>
                  <option key="Right Axis Deviation" value="Right Axis Deviation" >Right Axis Deviation</option>
                  <option key="Extreme Axis" value="Extreme Axis" >Extreme Axis</option>
                  <option key="-" value="-" >NA</option>
                </TextField>
              </Grid>
              <Grid item xs={6}>
                <Typography mt={1} variant="caption" sx={{ width: '100%' }} gutterBottom>
                  QTc = QT / √RR (ms) = <b>{formInput["qtc"] || ""}</b>
                </Typography>
              </Grid>
            </Grid>
            <AxisCalculator
              initialValues={formInput}
              onValuesChange={(vals) => setFormInputs(prev => ({ ...prev, ...vals }))}
            />

          </Card>

          <Card xs={12} className={customStyle.dotedBorder}>
            <LeadTraceMatrixSection
              ref={leadMatrixRef}
              leadKeys={reportData?.leads || []}
              metrices={metrices}
              metricesLabels={metricesLabels}
              notNormalMetrices={notNormalMetrices}
              initialValues={inputData?.ecg_quality_matrix || getDefaultLeadMetricesData()}
              onChange={(updatedData) => onLeadTraceMatrixUpdate(updatedData)}
              ecgReportData={reportData}
              inputFormData={formInput}
              isLTData={isLTData}
              leadReplica={leadReplica}
            />
          </Card>

          <Card xs={12} className={customStyle.dotedBorder}>
            <Grid container style={{ padding: "15px" }} spacing={2}>
              {inputData?.interpreted_report_file_metadata?.name ? <Grid item xs={12} textAlign="center">
                <Alert severity="success" sx={{ whiteSpace: 'break-word', wordBreak: 'break-all' }}>
                  <Tooltip title={inputData?.interpreted_report_file_metadata?.name}>
                    <Typography component="div">
                      Uploaded report:
                      <b> {inputData?.interpreted_report_file_metadata?.name}</b>
                    </Typography>
                  </Tooltip>
                </Alert>
              </Grid> : null}
              {/* <Grid item xs={12}>
                <TextField
                  name="interpreted_report_file"
                  type="file"
                  label="Upload interpreted report (optional)"
                  fullWidth
                  helperText={`Note: ${inputData?.interpreted_report_file_metadata?.name ? "Select to upload the updated report (if any)." : "If already interpreted then upload the report pdf."}`}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ accept: '.pdf' }}
                  onChange={handleChange}
                />
              </Grid> */}
              {/* <Grid item xs={12} sx={{ marginLeft: "15px", borderBottom: '1px dotted #000' }}></Grid> */}
              {/* <Grid item xs={12}>
                <FormControl fullWidth>
                  <CustomInputLabel>Select signature</CustomInputLabel>
                  <Select
                    name="signature_of"
                    value={formInput?.signature_of || ((signatures || []).length > 0 ?
                      (businessName || (subsDetails?.subscription_type?.toLowerCase() === "trial" || subsDetails?.subscription_type?.toLowerCase() === "paid" || reportData?.payment?.payment_id) ? (signatures.find(item => item["name"] === "Dr. Christianez Ratna") || signatures.find(item => item?.default))
                        : signatures.find(item => item["phoneNumber"] === expertPhoneNumber) || signatures.find(item => item?.default))["value"]
                      : null)
                    }
                    onChange={handleChange}
                    fullWidth
                    className={[customStyle.onFocus, "selectInputStyle"]}
                  >
                    {(signatures || []).map((item, index) => (
                      <MenuItem key={`sign-${index}`} value={item.value} selected={item.default}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>

                </FormControl>


              </Grid> */}


              <Grid item xs={12}>
                <FormControl fullWidth>
                  <CustomInputLabel>Select signature</CustomInputLabel>

                  {/* <Select
                    name="signature_of"
                    value={
                      formInput?.signature_of ||
                      (() => {
                        if (!signatures || signatures.length === 0) return "";

                        const subscriptionType =
                          subsDetails?.subscription_type?.toLowerCase();

                        // THis condition for trial / paid / business
                        if (
                          businessName ||
                          subscriptionType === "trial" ||
                          subscriptionType === "paid" ||
                          reportData?.payment?.payment_id
                        ) {
                          return (
                            signatures.find(
                              (item) => item.name === "Dr. Christianez Ratna"
                            )?.value ||
                            signatures.find((item) => item.default)?.value ||
                            ""
                          );
                        }

                        // This condition for free
                        return (
                          signatures.find(
                            (item) => item.phoneNumber === expertPhoneNumber
                          )?.value ||
                          signatures.find((item) => item.default)?.value ||
                          ""
                        );
                      })()
                    }
                    onChange={handleChange}
                    fullWidth
                    className={[customStyle.onFocus, "selectInputStyle"]}
                    renderValue={(selected) => {
                      const selectedSign = signatures.find(
                        (item) => item.value === selected
                      );
                      return selectedSign?.name || "";
                    }}
                  >
                    {(signatures || []).map((item, index) => (
                      <MenuItem
                        key={`sign-${index}`}
                        value={item.value}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" sx={{ fontSize: "15px" }}>
                          {item.name}
                        </Typography>

                        {item.qualification && (
                          <Chip
                            label={item.qualification}
                            size="small"
                            color="primary"
                            sx={{ ml: 2, fontSize: "10px" }}
                          />
                        )}
                      </MenuItem>
                    ))}
                  </Select> */}
                  <Select
                    name="signature_of"
                    value={formInput?.signature_of || ""}
                    onChange={handleChange}
                    fullWidth
                    className={[customStyle.onFocus, "selectInputStyle"]}
                    renderValue={(selected) => {
                      const selectedSign = signatures?.find(
                        (item) => item.value === selected
                      );
                      return selectedSign?.name || "";
                    }}
                  >
                    {(signatures || []).map((item, index) => (
                      <MenuItem
                        key={`sign-${index}`}
                        value={item.value}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" sx={{ fontSize: "15px" }}>
                          {item.name}
                        </Typography>

                        {item.qualification && (
                          <Chip
                            label={item.qualification}
                            size="small"
                            color="primary"
                            sx={{ ml: 2, fontSize: "10px" }}
                          />
                        )}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>


              <Grid item xs={12}>
                <div style={{ display: "flex" }}>
                  <FormControl>
                    <CustomInputLabel>Select report type (for segregation)</CustomInputLabel>
                    <RadioGroup row name="report_status" aria-labelledby="demo-row-radio-buttons-group-label" onChange={handleChange} value={formInput["report_status"] || "normal"}>
                      <FormControlLabel value="normal" control={<Radio />} label="Normal report" />
                      <FormControlLabel value="abnormal" control={<Radio />} label="Abnormal report" />
                      <FormControlLabel value="critical" control={<Radio />} label="Critical report" />
                      <FormControlLabel value="beyond_critical" control={<Radio />} label="Beyond Critical" />
                      <FormControlLabel value="retake" control={<Radio />} label="Retake" />
                    </RadioGroup>
                  </FormControl>
                </div>
              </Grid>
            </Grid>
          </Card>
        </Grid>

        {isLTData ?
          (reportData?.interpretation_data?.ecg_quality_matrix?.status !== "completed" && reportData?.interpretation_request_status === "completed") && (
            <div
              style={{ display: "flex", justifyContent: "center" }}
              className={customStyle.centerBtn}
            >
              <Button
                variant="contained"
                color="info"
                size="medium"
                onClick={handleSaveLTOData}
                disabled={savingLeadTrace}
              >
                {savingLeadTrace ? "Saving..." : "Save Lead Trace Data"}
              </Button>
            </div>
          )
          : <div style={{ display: "flex", justifyContent: "space-evenly" }} className={customStyle.centerBtn}>
            {/* {prescriptionButton && (
              <Button
                variant="outlined"
                color="info"
                size={reportData?.prescriptionUrl ? "small" : "medium"}
                onClick={handleOpenPrescription}
                startIcon={!prescriptionLoading && <EditIcon />} // hide icon when loading
                disabled={prescriptionLoading} // disable while loading
              >
                {prescriptionLoading
                  ? "Loading..."
                  : formInput["prescription_data"]
                    ? "Edit Prescription"
                    : "Prescription"}
              </Button>
            )} */}
            {prescriptionButton && formInput["prescription_data"] && (
              <Button
                variant="outlined"
                color="info"
                size="small"
                onClick={handleOpenPrescription}
                startIcon={!prescriptionLoading && <EditIcon />}
                disabled={prescriptionLoading}
              >
                {prescriptionLoading ? "Loading..." : "Edit Prescription"}
              </Button>
            )}

            {reportData?.prescriptionUrl && (
              <Button
                variant="outlined"
                color="info"
                size="small"
                onClick={() => {
                  window.open(reportData.prescriptionUrl, "_blank", "noopener,noreferrer");
                }}
                startIcon={!prescriptionLoading && <DownloadIcon />}
                disabled={prescriptionLoading}
              >
                {prescriptionLoading ? "Opening..." : "Download Prescription"}
              </Button>
            )}
            {/* <Button variant="contained" type="submit" color="info" disabled={pdfLoading ? true : false}>
            {pdfLoading ? 'Loading....' : 'Save & Generate Report'}
          </Button> */}
            <Button variant="contained" type="submit" color="info" disabled={pdfLoading}>
              {pdfLoading ? "Loading…" : "Save & Generate Report"}
            </Button>

          </div>}
        <Dialog open={isDialogOpen} onClose={onCloseDialog} disableScrollLock={false}>
          <DialogTitle>Confirm Save & Generate Report</DialogTitle>
          <DialogContent>
            <Typography>Before generating the report, please review the following details to ensure accuracy:</Typography>
            <List>
              <ListItem key={0}>
                <b>• Signature:</b><ListItemText sx={{ pl: 2 }} primary={`${signatures.find(sign => sign?.value === formInput?.signature_of)?.name || 'Not selected'}`} />
              </ListItem>
              <ListItem key={1}>
                <b>• Report Status: </b><ListItemText sx={{ pl: 2 }} primary={`${formInput?.report_status || 'Not selected'}`} />
              </ListItem>
            </List>
            <Typography variant="body1">
              Please confirm the details above are correct before proceeding.
            </Typography>
            {referralOptions.length > 0 && (
              <FormControl component="fieldset" margin="normal">
                <FormLabel component="legend">Referral Options</FormLabel>
                <RadioGroup
                  aria-label="referred-to"
                  name="referred-to-radio-group"
                  value={referredToValue}
                  onChange={(e) => {
                    setReferredToValue(e.target.value);
                  }}
                  row
                >
                  {referralOptions.map((option) => (
                    <FormControlLabel
                      key={option.value}
                      value={option.value}
                      control={
                        <Radio
                          onClick={(e) => {
                            // If clicking selected radio → unselect it
                            if (referredToValue === option.value) {
                              e.stopPropagation();
                              setReferredToValue("");
                            }
                          }}
                        />
                      }
                      label={option.label}
                    />
                  ))}
                </RadioGroup>

              </FormControl>
            )}

          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 3, gap: 3 }}>
            <Button onClick={onCloseDialog} color="primary" variant="outlined">
              Cancel
            </Button>

            <Button
              color="primary"
              variant="outlined"
              disabled={saveAndCloseLoading}
              onClick={async (e) => {
                try {
                  setSaveAndCloseLoading(true);
                  await onConfirmSubmitClick(e, false); // no pdfLoading inside
                  onCloseDialog();
                  if (leadReplica) {
                    navigate(`${process.env.REACT_APP_HOMEPAGE}dashboard/all-ecg-reports`);
                  } else {
                    navigate(`${process.env.REACT_APP_HOMEPAGE}dashboard/allReports`);
                  }
                } catch (error) {
                  console.error("Error during save and close:", error);
                } finally {
                  setSaveAndCloseLoading(false);
                }
              }}
            >
              {saveAndCloseLoading ? 'Saving...' : 'Save and Close'}
            </Button>

            <Button
              onClick={(e) => onConfirmSubmitClick(e, true)}
              color="primary"
              variant="contained"
              disabled={pdfLoading ? true : false}
              autoFocus
            >
              {pdfLoading ? 'Saving...' : 'Save'}
            </Button>
          </DialogActions>


        </Dialog>
      </form>
      <Dialog open={openPrescription} fullScreen>
        <AppBar position="relative" color="default" elevation={1}>
          <Toolbar sx={{ justifyContent: 'space-between' }}>
            <Box display="flex" alignItems="center">
              <IconButton edge="start" color="inherit" onClick={handleClosePrescription} aria-label="back">
                <ArrowBackIcon />
              </IconButton>
            </Box>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1, textAlign: 'center', ml: -6 }}>
              Write Prescription
            </Typography>
            <Box sx={{ width: 48 }} /> {/* Spacer to balance center alignment */}
          </Toolbar>
        </AppBar>

        <DialogContent sx={{ padding: 2 }}>
          <DoctorPrescription
            patientData={inputData}
            prescriptionData={prescriptionContent}
            bodyVitals={formInput?.vitals}
            onContentChange={handleContentChange}
            formInput={formInput}
          />
        </DialogContent>


      </Dialog>

    </>
  );
}

export default CustomReportInputForm;


//Backup element for future use so please don't remove below lines
{/* <Grid pt={ 2 } xs={12}>
          <FormControl fullWidth>
            <CustomInputLabel>Arrhythmia</CustomInputLabel>
            <Autocomplete
              multiple
              id={`choose-arrhythmia-${formKey}` }
              className={customStyle.onFocus}
              onChange={handleArrhymiaChange}
              name="ArrhythmiaKey"
              options={arryhthmiaData}
              disableCloseOnSelect
              getOptionLabel={(option) => option.title}
              renderOption={(props, option, { selected }) => (
                <li {...props} data-key='ArrhythmiaKey'>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.title}
                </li>
              )}
              renderInput={(params) => {
                return (<TextField {...params} name='ArrhythmiaKey' placeholder="Choose Multiple" />)
              }}
            />
          </FormControl>
        </Grid> 
        <Grid pt={ 2 } xs={12}>
          <FormControl fullWidth>
            <Autocomplete
              multiple
              id={`choose-stemi-${formKey}` }
              className={customStyle.onFocus}
              onChange={handleStemiChange}
              name="StemiKey"
              data-key='StemiKey'
              options={stemiData}
              disableCloseOnSelect
              getOptionLabel={(option) => option.title}
              renderOption={(props, option, { selected }) => (
                <li {...props} data-key='StemiKey'>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.title}
                </li>
              )}
              renderInput={(params) => {
                return (<TextField {...params} name='StemiKey' data-key='StemiKey' placeholder="Choose Multiple" />)
              }}
            />
          </FormControl>
        </Grid> */}